import { X, Ban, RotateCcw } from 'lucide-react';
import type { Town } from '@shared/types/town';
import { formatNumber } from '@shared/utils/format';

interface PanelHeaderProps {
    town: Town;
    onClose: () => void;
    onExclude?: () => void;
    onRestore?: () => void;
    isStatusChanging?: boolean;
}

export default function PanelHeader({ town, onClose, onExclude, onRestore, isStatusChanging }: PanelHeaderProps) {
    return (
        <div className="flex items-center justify-between px-6 py-4 border-b border-[#E6E9ED] bg-[#F5F7FA]">
            <div>
                <h2 className="text-[15px] font-bold text-[#2A3F54]">{town.name}</h2>
                <p className="text-[11px] text-[#ADB5BD] mt-0.5">
                    {town.address ?? ''} · {formatNumber(town.household_count)}세대
                </p>
            </div>
            <div className="flex items-center gap-2">
                {town.status !== 'excluded' && onExclude && (
                    <button
                        onClick={onExclude}
                        disabled={isStatusChanging}
                        className="inline-flex items-center gap-1 px-2.5 py-1.5 text-[11px] font-medium text-[#E74C3C] border border-[#E74C3C]/30 rounded hover:bg-[#E74C3C]/5 transition disabled:opacity-50"
                    >
                        <Ban className="w-3 h-3" />
                        단지관리에서 제외
                    </button>
                )}
                {town.status === 'excluded' && onRestore && (
                    <button
                        onClick={onRestore}
                        disabled={isStatusChanging}
                        className="inline-flex items-center gap-1 px-2.5 py-1.5 text-[11px] font-medium text-[#1ABB9C] border border-[#1ABB9C]/30 rounded hover:bg-[#1ABB9C]/5 transition disabled:opacity-50"
                    >
                        <RotateCcw className="w-3 h-3" />
                        복구
                    </button>
                )}
                {town.status === 'excluded' && (
                    <span className="inline-flex items-center gap-1 px-2.5 py-1 text-[10px] font-semibold rounded bg-[#E6E9ED] text-[#73879C]">
                        제외
                    </span>
                )}
                <button
                    onClick={onClose}
                    className="w-7 h-7 rounded hover:bg-[#E6E9ED] flex items-center justify-center transition"
                >
                    <X className="w-4 h-4 text-[#73879C]" />
                </button>
            </div>
        </div>
    );
}
